import { taxConstants, } from '_constants';

const initialState = {};

export function taxData(state = initialState, action) {
    switch(action.type) {
        // Get Reviews
        case taxConstants.TICKET_TAX_BREAKDOWN_REQUEST:
            return {
                ...state,
                fetchingTicketTaxBreakdown: true,
            };
        case taxConstants.TICKET_TAX_BREAKDOWN_SUCCESS:
            return {
                ...state,
                fetchingTicketTaxBreakdown: false,
                tickets_tax_breakdown: action.data.tickets_tax_breakdown,
            };
        case taxConstants.TICKET_TAX_BREAKDOWN_FAILURE:
            return {
                ...state,
                fetchingTicketTaxBreakdown: false,
            };
        case taxConstants.TICKET_TAX_TERMS_QUERY_REQUEST:
            return {
                ...state,
                fetchingTicketTaxTermsStatus: true,
            };
        case taxConstants.TICKET_TAX_TERMS_QUERY_SUCCESS:
            return {
                ...state,
                fetchingTicketTaxTermsStatus: false,
                ticketTaxNeedsRenewal: action.data.renew,
                ticketTaxAcceptedVersion: action.data.accepted_version,
                ticketTaxLatestVersion: action.data.latest_version,
                ticketTaxPolicyURL: action.data.policy,

                
            };
        case taxConstants.TICKET_TAX_TERMS_QUERY_FAILURE:
            return {
                ...state,
                fetchingTicketTaxTermsStatus: false,
            };
        case taxConstants.TICKET_TAX_TERMS_ACCEPTED_REQUEST:
            return {
                ...state,
                acceptTicketTaxTermsRequest: true,
            };
        case taxConstants.TICKET_TAX_TERMS_ACCEPTED_SUCCESS:
            return {
                ...state,
                acceptTicketTaxTermsRequest: false,
                ticketTaxAcceptedVersion: action.data.accepted_version,
            };
        case taxConstants.TICKET_TAX_TERMS_ACCEPTED_FAILURE:
            return {
                ...state,
                acceptTicketTaxTermsRequest: false,
            };
        default:
            return state;
    }
};

